// extracted by mini-css-extract-plugin
export default {"previewContainer":"PreviewConfigFile_previewContainer__2DDhM","textContainer":"PreviewConfigFile_textContainer__2FCsY"};